var items = {
  "block.minecraft.air": "hava",
  "block.minecraft.stone": "taş",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "cilalı granit",
  "block.minecraft.diorite": "diyorit",
  "block.minecraft.polished_diorite": "cilalı diyorit",
  "block.minecraft.andesite": "andezit",
  "block.minecraft.polished_andesite": "cilalı andezit",
  "block.minecraft.grass_block": "çimenli toprak",
  "block.minecraft.dirt": "toprak",
  "block.minecraft.coarse_dirt": "i̇ri taneli toprak",
  "block.minecraft.podzol": "podzol",
  "block.minecraft.crimson_nylium": "kızıl nesilyum",
  "block.minecraft.warped_nylium": "çarpık niselyum",
  "block.minecraft.cobblestone": "kırık taş",
  "block.minecraft.oak_planks": "meşe tahta",
  "block.minecraft.spruce_planks": "ladin tahta",
  "block.minecraft.birch_planks": "huş tahta",
  "block.minecraft.jungle_planks": "orman ağacı tahta",
  "block.minecraft.acacia_planks": "akasya tahta",
  "block.minecraft.dark_oak_planks": "koyu meşe tahta",
  "block.minecraft.crimson_planks": "kızıl tahta",
  "block.minecraft.warped_planks": "çarpık tahta",
  "block.minecraft.oak_sapling": "meşe fidanı",
  "block.minecraft.spruce_sapling": "ladin fidanı",
  "block.minecraft.birch_sapling": "huş fidanı",
  "block.minecraft.jungle_sapling": "orman ağacı fidanı",
  "block.minecraft.acacia_sapling": "akasya fidanı",
  "block.minecraft.dark_oak_sapling": "koyu meşe fidanı",
  "block.minecraft.bedrock": "katman kayası",
  "block.minecraft.sand": "kum",
  "block.minecraft.red_sand": "kırmızı kum",
  "block.minecraft.gravel": "çakıl",
  "block.minecraft.gold_ore": "altın cevheri",
  "block.minecraft.iron_ore": "demir cevheri",
  "block.minecraft.coal_ore": "kömür cevheri",
  "block.minecraft.nether_gold_ore": "nether altını cevheri",
  "block.minecraft.oak_log": "meşe kütüğü",
  "block.minecraft.spruce_log": "ladin kütüğü",
  "block.minecraft.birch_log": "huş kütüğü",
  "block.minecraft.jungle_log": "orman ağacı kütüğü",
  "block.minecraft.acacia_log": "akasya kütüğü",
  "block.minecraft.dark_oak_log": "koyu meşe kütüğü",
  "block.minecraft.crimson_stem": "kızıl kök",
  "block.minecraft.warped_stem": "çarpık kök",
  "block.minecraft.stripped_oak_log": "soyulmuş meşe kütüğü",
  "block.minecraft.stripped_spruce_log": "soyulmuş ladin kütüğü",
  "block.minecraft.stripped_birch_log": "soyulmuş huş kütüğü",
  "block.minecraft.stripped_jungle_log": "soyulmuş orman ağacı kütüğü",
  "block.minecraft.stripped_acacia_log": "soyulmuş akasya kütüğü",
  "block.minecraft.stripped_dark_oak_log": "soyulmuş koyu meşe kütüğü",
  "block.minecraft.stripped_crimson_stem": "soyulmuş kızıl kök",
  "block.minecraft.stripped_warped_stem": "soyulmuş çarpık kök",
  "block.minecraft.stripped_oak_wood": "soyulmuş meşe odunu",
  "block.minecraft.stripped_spruce_wood": "soyulmuş ladin odunu",
  "block.minecraft.stripped_birch_wood": "soyulmuş huş odunu",
  "block.minecraft.stripped_jungle_wood": "soyulmuş orman ağacı odunu",
  "block.minecraft.stripped_acacia_wood": "soyulmuş akasya odunu",
  "block.minecraft.stripped_dark_oak_wood": "soyulmuş koyu meşe odunu",
  "block.minecraft.stripped_crimson_hyphae": "soyulmuş kızıl hif",
  "block.minecraft.stripped_warped_hyphae": "soyulmuş çarpık hif",
  "block.minecraft.oak_wood": "meşe odunu",
  "block.minecraft.spruce_wood": "ladin odunu",
  "block.minecraft.birch_wood": "huş odunu",
  "block.minecraft.jungle_wood": "orman ağacı odunu",
  "block.minecraft.acacia_wood": "akasya odunu",
  "block.minecraft.dark_oak_wood": "koyu meşe odunu",
  "block.minecraft.crimson_hyphae": "kızıl hif",
  "block.minecraft.warped_hyphae": "çarpık hif",
  "block.minecraft.oak_leaves": "meşe yaprakları",
  "block.minecraft.spruce_leaves": "ladin yaprakları",
  "block.minecraft.birch_leaves": "huş yaprakları",
  "block.minecraft.jungle_leaves": "orman ağacı yaprakları",
  "block.minecraft.acacia_leaves": "akasya yaprakları",
  "block.minecraft.dark_oak_leaves": "koyu meşe yaprakları",
  "block.minecraft.sponge": "sünger",
  "block.minecraft.wet_sponge": "islak sünger",
  "block.minecraft.glass": "cam",
  "block.minecraft.lapis_ore": "lapis lazuli cevheri",
  "block.minecraft.lapis_block": "lapis lazuli bloğu",
  "block.minecraft.dispenser": "fırlatıcı",
  "block.minecraft.sandstone": "kum taşı",
  "block.minecraft.chiseled_sandstone": "oyma kum taşı",
  "block.minecraft.cut_sandstone": "kesilmiş kum taşı",
  "block.minecraft.note_block": "nota bloğu",
  "block.minecraft.powered_rail": "güçlendirilmiş ray",
  "block.minecraft.detector_rail": "algılayıcı ray",
  "block.minecraft.sticky_piston": "yapışkan piston",
  "block.minecraft.cobweb": "örümcek ağı",
  "block.minecraft.grass": "çimen",
  "block.minecraft.fern": "eğrelti",
  "block.minecraft.dead_bush": "ölü bitki",
  "block.minecraft.seagrass": "deniz otu",
  "block.minecraft.sea_pickle": "pirozom",
  "block.minecraft.piston": "piston",
  "block.minecraft.white_wool": "beyaz yün",
  "block.minecraft.orange_wool": "turuncu yün",
  "block.minecraft.magenta_wool": "eflatun yün",
  "block.minecraft.light_blue_wool": "açık mavi yün",
  "block.minecraft.yellow_wool": "sarı yün",
  "block.minecraft.lime_wool": "açık yeşil yün",
  "block.minecraft.pink_wool": "pembe yün",
  "block.minecraft.gray_wool": "gri yün",
  "block.minecraft.light_gray_wool": "açık gri yün",
  "block.minecraft.cyan_wool": "camgöbeği yün",
  "block.minecraft.purple_wool": "mor yün",
  "block.minecraft.blue_wool": "mavi yün",
  "block.minecraft.brown_wool": "kahverengi yün",
  "block.minecraft.green_wool": "yeşil yün",
  "block.minecraft.red_wool": "kırmızı yün",
  "block.minecraft.black_wool": "siyah yün",
  "block.minecraft.dandelion": "karahindiba",
  "block.minecraft.poppy": "gelincik",
  "block.minecraft.blue_orchid": "mavi orkide",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "hüstonya",
  "block.minecraft.red_tulip": "kırmızı lale",
  "block.minecraft.orange_tulip": "turuncu lale",
  "block.minecraft.white_tulip": "beyaz lale",
  "block.minecraft.pink_tulip": "pembe lale",
  "block.minecraft.oxeye_daisy": "papatya",
  "block.minecraft.cornflower": "mavi kantaron",
  "block.minecraft.lily_of_the_valley": "i̇nci çiçeği",
  "block.minecraft.wither_rose": "wither gülü",
  "block.minecraft.brown_mushroom": "kahverengi mantar",
  "block.minecraft.red_mushroom": "kırmızı mantar",
  "block.minecraft.crimson_fungus": "kızıl mantar",
  "block.minecraft.warped_fungus": "çarpık mantar",
  "block.minecraft.crimson_roots": "kızıl kökler",
  "block.minecraft.warped_roots": "çarpık kökler",
  "block.minecraft.nether_sprouts": "nether filizleri",
  "block.minecraft.weeping_vines": "ağlayan sarmaşık",
  "block.minecraft.twisting_vines": "bükük sarmaşık",
  "block.minecraft.sugar_cane": "şeker kamışı",
  "block.minecraft.kelp": "su yosunu",
  "block.minecraft.bamboo": "bambu",
  "block.minecraft.gold_block": "altın bloğu",
  "block.minecraft.iron_block": "demir bloğu",
  "block.minecraft.oak_slab": "meşe basamak",
  "block.minecraft.spruce_slab": "ladin basamak",
  "block.minecraft.birch_slab": "huş basamak",
  "block.minecraft.jungle_slab": "orman ağacı basamak",
  "block.minecraft.acacia_slab": "akasya basamak",
  "block.minecraft.dark_oak_slab": "koyu meşe basamak",
  "block.minecraft.crimson_slab": "kızıl basamak",
  "block.minecraft.warped_slab": "çarpık basamak",
  "block.minecraft.stone_slab": "taş basamak",
  "block.minecraft.smooth_stone_slab": "düzgün taş basamak",
  "block.minecraft.sandstone_slab": "kum taşı basamak",
  "block.minecraft.cut_sandstone_slab": "kesik kum taşı basamak",
  "block.minecraft.petrified_oak_slab": "taşlaşmış meşe basamak",
  "block.minecraft.cobblestone_slab": "kırık taş basamak",
  "block.minecraft.brick_slab": "tuğla basamak",
  "block.minecraft.stone_brick_slab": "taş tuğla basamak",
  "block.minecraft.nether_brick_slab": "nether tuğlası basamak",
  "block.minecraft.quartz_slab": "kuvars basamak",
  "block.minecraft.red_sandstone_slab": "kırmızı kum taşı basamak",
  "block.minecraft.cut_red_sandstone_slab": "kesik kırmızı kum taşı basamak",
  "block.minecraft.purpur_slab": "purpur basamak",
  "block.minecraft.prismarine_slab": "prizmarin basamak",
  "block.minecraft.prismarine_brick_slab": "prizmarin tuğlası basamak",
  "block.minecraft.dark_prismarine_slab": "koyu prizmarin basamak",
  "block.minecraft.smooth_quartz": "düzgün kuvars bloğu",
  "block.minecraft.smooth_red_sandstone": "düzgün kırmızı kum taşı",
  "block.minecraft.smooth_sandstone": "düzgün kum taşı",
  "block.minecraft.smooth_stone": "düzgün taş",
  "block.minecraft.bricks": "tuğla",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "kitaplık",
  "block.minecraft.mossy_cobblestone": "yosunlu kırık taş",
  "block.minecraft.obsidian": "obsidyen",
  "block.minecraft.torch": "meşale",
  "block.minecraft.end_rod": "end çubuğu",
  "block.minecraft.chorus_plant": "nakarat bitkisi",
  "block.minecraft.chorus_flower": "nakarat çiçeği",
  "block.minecraft.purpur_block": "purpur bloğu",
  "block.minecraft.purpur_pillar": "purpur sütun",
  "block.minecraft.purpur_stairs": "purpur merdiven",
  "block.minecraft.spawner": "çağırıcı",
  "block.minecraft.oak_stairs": "meşe merdiven",
  "block.minecraft.chest": "sandık",
  "block.minecraft.diamond_ore": "elmas cevheri",
  "block.minecraft.diamond_block": "elmas bloğu",
  "block.minecraft.crafting_table": "çalışma masası",
  "block.minecraft.farmland": "tarım arazisi",
  "block.minecraft.furnace": "fırın",
  "block.minecraft.ladder": "merdiven",
  "block.minecraft.rail": "ray",
  "block.minecraft.cobblestone_stairs": "kırık taş merdiven",
  "block.minecraft.lever": "şalter",
  "block.minecraft.stone_pressure_plate": "taş basınç plakası",
  "block.minecraft.oak_pressure_plate": "meşe basınç plakası",
  "block.minecraft.spruce_pressure_plate": "ladin basınç plakası",
  "block.minecraft.birch_pressure_plate": "huş basınç plakası",
  "block.minecraft.jungle_pressure_plate": "orman ağacı basınç plakası",
  "block.minecraft.acacia_pressure_plate": "akasya basınç plakası",
  "block.minecraft.dark_oak_pressure_plate": "koyu meşe basınç plakası",
  "block.minecraft.crimson_pressure_plate": "kızıl basınç plakası",
  "block.minecraft.warped_pressure_plate": "çarpık basınç plakası",
  "block.minecraft.polished_blackstone_pressure_plate": "cilalı kara taş basınç plakası",
  "block.minecraft.redstone_ore": "kızıl taş cevheri",
  "block.minecraft.redstone_torch": "kızıl taş meşalesi",
  "block.minecraft.snow": "kar",
  "block.minecraft.ice": "buz",
  "block.minecraft.snow_block": "kar bloğu",
  "block.minecraft.cactus": "kaktüs",
  "block.minecraft.clay": "kil",
  "block.minecraft.jukebox": "müzik kutusu",
  "block.minecraft.oak_fence": "meşe çit",
  "block.minecraft.spruce_fence": "ladin çit",
  "block.minecraft.birch_fence": "huş çit",
  "block.minecraft.jungle_fence": "orman ağacı çit",
  "block.minecraft.acacia_fence": "akasya çit",
  "block.minecraft.dark_oak_fence": "koyu meşe çit",
  "block.minecraft.crimson_fence": "kızıl çit",
  "block.minecraft.warped_fence": "çarpık çit",
  "block.minecraft.pumpkin": "bal kabağı",
  "block.minecraft.carved_pumpkin": "oyma bal kabağı",
  "block.minecraft.netherrack": "nether taşı",
  "block.minecraft.soul_sand": "ruh kumu",
  "block.minecraft.soul_soil": "ruh toprağı",
  "block.minecraft.basalt": "bazalt",
  "block.minecraft.polished_basalt": "cilalı bazalt",
  "block.minecraft.soul_torch": "ruh meşalesi",
  "block.minecraft.glowstone": "işık taşı",
  "block.minecraft.jack_o_lantern": "bal kabağı lambası",
  "block.minecraft.oak_trapdoor": "meşe tuzak kapısı",
  "block.minecraft.spruce_trapdoor": "ladin tuzak kapısı",
  "block.minecraft.birch_trapdoor": "huş tuzak kapısı",
  "block.minecraft.jungle_trapdoor": "orman ağacı tuzak kapısı",
  "block.minecraft.acacia_trapdoor": "akasya tuzak kapısı",
  "block.minecraft.dark_oak_trapdoor": "koyu meşe tuzak kapısı",
  "block.minecraft.crimson_trapdoor": "kızıl tuzak kapısı",
  "block.minecraft.warped_trapdoor": "çarpık tuzak kapısı",
  "block.minecraft.infested_stone": "enfekte taş",
  "block.minecraft.infested_cobblestone": "enfekte kırık taş",
  "block.minecraft.infested_stone_bricks": "enfekte taş tuğla",
  "block.minecraft.infested_mossy_stone_bricks": "enfekte yosunlu taş tuğla",
  "block.minecraft.infested_cracked_stone_bricks": "enfekte kırık taş tuğla",
  "block.minecraft.infested_chiseled_stone_bricks": "enfekte oyma taş tuğla",
  "block.minecraft.stone_bricks": "taş tuğla",
  "block.minecraft.mossy_stone_bricks": "yosunlu taş tuğla",
  "block.minecraft.cracked_stone_bricks": "çatlak taş tuğla",
  "block.minecraft.chiseled_stone_bricks": "oyma taş tuğla",
  "block.minecraft.brown_mushroom_block": "kahverengi mantar bloğu",
  "block.minecraft.red_mushroom_block": "kırmızı mantar bloğu",
  "block.minecraft.mushroom_stem": "mantar sapı",
  "block.minecraft.iron_bars": "demir parmaklık",
  "block.minecraft.chain": "zincir",
  "block.minecraft.glass_pane": "i̇nce cam",
  "block.minecraft.melon": "karpuz",
  "block.minecraft.vine": "sarmaşık",
  "block.minecraft.oak_fence_gate": "meşe çit kapısı",
  "block.minecraft.spruce_fence_gate": "ladin çit kapısı",
  "block.minecraft.birch_fence_gate": "huş çit kapısı",
  "block.minecraft.jungle_fence_gate": "orman ağacı çit kapısı",
  "block.minecraft.acacia_fence_gate": "akasya çit kapısı",
  "block.minecraft.dark_oak_fence_gate": "koyu meşe çit kapısı",
  "block.minecraft.crimson_fence_gate": "kızıl çit kapısı",
  "block.minecraft.warped_fence_gate": "çarpık çit kapısı",
  "block.minecraft.brick_stairs": "tuğla merdiven",
  "block.minecraft.stone_brick_stairs": "taş tuğla merdiven",
  "block.minecraft.mycelium": "miselyum",
  "block.minecraft.lily_pad": "nilüfer",
  "block.minecraft.nether_bricks": "nether tuğlası",
  "block.minecraft.cracked_nether_bricks": "çatlak nether tuğlası",
  "block.minecraft.chiseled_nether_bricks": "oyma nether tuğlası",
  "block.minecraft.nether_brick_fence": "nether tuğlası çit",
  "block.minecraft.nether_brick_stairs": "nether tuğlası merdiveni",
  "block.minecraft.enchanting_table": "büyü masası",
  "block.minecraft.end_portal_frame": "end geçidi çerçevesi",
  "block.minecraft.end_stone": "end taşı",
  "block.minecraft.end_stone_bricks": "end taşı tuğla",
  "block.minecraft.dragon_egg": "ejderha yumurtası",
  "block.minecraft.redstone_lamp": "kızıl taş lambası",
  "block.minecraft.sandstone_stairs": "kum taşı merdiven",
  "block.minecraft.emerald_ore": "zümrüt cevheri",
  "block.minecraft.ender_chest": "ender sandığı",
  "block.minecraft.tripwire_hook": "tuzak kancası",
  "block.minecraft.emerald_block": "zümrüt bloğu",
  "block.minecraft.spruce_stairs": "ladin merdiven",
  "block.minecraft.birch_stairs": "huş merdiven",
  "block.minecraft.jungle_stairs": "orman ağacı merdiven",
  "block.minecraft.crimson_stairs": "kızıl merdiven",
  "block.minecraft.warped_stairs": "çarpık merdiven",
  "block.minecraft.command_block": "komut bloğu",
  "block.minecraft.beacon": "fener",
  "block.minecraft.cobblestone_wall": "kırık taş duvar",
  "block.minecraft.mossy_cobblestone_wall": "yosunlu kırık taş duvar",
  "block.minecraft.brick_wall": "tuğla duvar",
  "block.minecraft.prismarine_wall": "prizmarin duvar",
  "block.minecraft.red_sandstone_wall": "kırmızı kum taşı duvar",
  "block.minecraft.mossy_stone_brick_wall": "yosunlu taş tuğla duvar",
  "block.minecraft.granite_wall": "granit duvar",
  "block.minecraft.stone_brick_wall": "taş tuğla duvar",
  "block.minecraft.nether_brick_wall": "nether tuğlası duvar",
  "block.minecraft.andesite_wall": "andezit duvar",
  "block.minecraft.red_nether_brick_wall": "kırmızı nether tuğlası duvar",
  "block.minecraft.sandstone_wall": "kum taşı duvar",
  "block.minecraft.end_stone_brick_wall": "end taşı tuğlası duvar",
  "block.minecraft.diorite_wall": "diyorit duvar",
  "block.minecraft.blackstone_wall": "kara taş duvar",
  "block.minecraft.polished_blackstone_wall": "cilalı kara taş duvar",
  "block.minecraft.polished_blackstone_brick_wall": "cilalı kara taş tuğla duvar",
  "block.minecraft.stone_button": "taş düğme",
  "block.minecraft.oak_button": "meşe düğme",
  "block.minecraft.spruce_button": "ladin düğme",
  "block.minecraft.birch_button": "huş düğme",
  "block.minecraft.jungle_button": "orman ağacı düğme",
  "block.minecraft.acacia_button": "akasya düğme",
  "block.minecraft.dark_oak_button": "koyu meşe düğme",
  "block.minecraft.crimson_button": "kızıl düğme",
  "block.minecraft.warped_button": "çarpık düğme",
  "block.minecraft.polished_blackstone_button": "cilalı kara taş düğme",
  "block.minecraft.anvil": "örs",
  "block.minecraft.chipped_anvil": "çizilmiş örs",
  "block.minecraft.damaged_anvil": "hasarlı örs",
  "block.minecraft.trapped_chest": "tuzaklı sandık",
  "block.minecraft.light_weighted_pressure_plate": "hassas ağırlıklı basınç plakası",
  "block.minecraft.heavy_weighted_pressure_plate": "sert ağırlıklı basınç plakası",
  "block.minecraft.daylight_detector": "gün işığı algılayıcısı",
  "block.minecraft.redstone_block": "kızıl taş bloğu",
  "block.minecraft.nether_quartz_ore": "nether kuvarsı cevheri",
  "block.minecraft.hopper": "huni",
  "block.minecraft.chiseled_quartz_block": "oyma kuvars bloğu",
  "block.minecraft.quartz_block": "kuvars bloğu",
  "block.minecraft.quartz_bricks": "kuvars tuğla",
  "block.minecraft.quartz_pillar": "kuvars sütun",
  "block.minecraft.quartz_stairs": "kuvars merdiveni",
  "block.minecraft.activator_rail": "aktifleyici ray",
  "block.minecraft.dropper": "bırakıcı",
  "block.minecraft.white_terracotta": "beyaz terakota",
  "block.minecraft.orange_terracotta": "turuncu terakota",
  "block.minecraft.magenta_terracotta": "eflatun terakota",
  "block.minecraft.light_blue_terracotta": "açık mavi terakota",
  "block.minecraft.yellow_terracotta": "sarı terakota",
  "block.minecraft.lime_terracotta": "açık yeşil terakota",
  "block.minecraft.pink_terracotta": "pembe terakota",
  "block.minecraft.gray_terracotta": "gri terakota",
  "block.minecraft.light_gray_terracotta": "açık gri terakota",
  "block.minecraft.cyan_terracotta": "camgöbeği terakota",
  "block.minecraft.purple_terracotta": "mor terakota",
  "block.minecraft.blue_terracotta": "mavi terakota",
  "block.minecraft.brown_terracotta": "kahverengi terakota",
  "block.minecraft.green_terracotta": "yeşil terakota",
  "block.minecraft.red_terracotta": "kırmızı terakota",
  "block.minecraft.black_terracotta": "siyah terakota",
  "block.minecraft.barrier": "bariyer",
  "block.minecraft.iron_trapdoor": "demir tuzak kapısı",
  "block.minecraft.hay_block": "saman balyası",
  "block.minecraft.white_carpet": "beyaz halı",
  "block.minecraft.orange_carpet": "turuncu halı",
  "block.minecraft.magenta_carpet": "eflatun halı",
  "block.minecraft.light_blue_carpet": "açık mavi halı",
  "block.minecraft.yellow_carpet": "sarı halı",
  "block.minecraft.lime_carpet": "açık yeşil halı",
  "block.minecraft.pink_carpet": "pembe halı",
  "block.minecraft.gray_carpet": "gri halı",
  "block.minecraft.light_gray_carpet": "açık gri halı",
  "block.minecraft.cyan_carpet": "camgöbeği halı",
  "block.minecraft.purple_carpet": "mor halı",
  "block.minecraft.blue_carpet": "mavi halı",
  "block.minecraft.brown_carpet": "kahverengi halı",
  "block.minecraft.green_carpet": "yeşil halı",
  "block.minecraft.red_carpet": "kırmızı halı",
  "block.minecraft.black_carpet": "siyah halı",
  "block.minecraft.terracotta": "terakota",
  "block.minecraft.coal_block": "kömür bloğu",
  "block.minecraft.packed_ice": "paketlenmiş buz",
  "block.minecraft.acacia_stairs": "akasya merdiven",
  "block.minecraft.dark_oak_stairs": "koyu meşe merdiven",
  "block.minecraft.slime_block": "balçık bloğu",
  "block.minecraft.grass_path": "çimen yol",
  "block.minecraft.sunflower": "ayçiçeği",
  "block.minecraft.lilac": "leylak",
  "block.minecraft.rose_bush": "gül çalılığı",
  "block.minecraft.peony": "şakayık",
  "block.minecraft.tall_grass": "uzun çimen",
  "block.minecraft.large_fern": "büyük eğrelti",
  "block.minecraft.white_stained_glass": "beyaz boyalı cam",
  "block.minecraft.orange_stained_glass": "turuncu boyalı cam",
  "block.minecraft.magenta_stained_glass": "eflatun boyalı cam",
  "block.minecraft.light_blue_stained_glass": "açık mavi boyalı cam",
  "block.minecraft.yellow_stained_glass": "sarı boyalı cam",
  "block.minecraft.lime_stained_glass": "açık yeşil boyalı cam",
  "block.minecraft.pink_stained_glass": "pembe boyalı cam",
  "block.minecraft.gray_stained_glass": "gri boyalı cam",
  "block.minecraft.light_gray_stained_glass": "açık gri boyalı cam",
  "block.minecraft.cyan_stained_glass": "camgöbeği boyalı cam",
  "block.minecraft.purple_stained_glass": "mor boyalı cam",
  "block.minecraft.blue_stained_glass": "mavi boyalı cam",
  "block.minecraft.brown_stained_glass": "kahverengi boyalı cam",
  "block.minecraft.green_stained_glass": "yeşil boyalı cam",
  "block.minecraft.red_stained_glass": "kırmızı boyalı cam",
  "block.minecraft.black_stained_glass": "siyah boyalı cam",
  "block.minecraft.white_stained_glass_pane": "beyaz boyalı i̇nce cam",
  "block.minecraft.orange_stained_glass_pane": "turuncu boyalı i̇nce cam",
  "block.minecraft.magenta_stained_glass_pane": "eflatun boyalı i̇nce cam",
  "block.minecraft.light_blue_stained_glass_pane": "açık mavi boyalı i̇nce cam",
  "block.minecraft.yellow_stained_glass_pane": "sarı boyalı i̇nce cam",
  "block.minecraft.lime_stained_glass_pane": "açık yeşil boyalı i̇nce cam",
  "block.minecraft.pink_stained_glass_pane": "pembe boyalı i̇nce cam",
  "block.minecraft.gray_stained_glass_pane": "gri boyalı i̇nce cam",
  "block.minecraft.light_gray_stained_glass_pane": "açık gri boyalı i̇nce cam",
  "block.minecraft.cyan_stained_glass_pane": "camgöbeği boyalı i̇nce cam",
  "block.minecraft.purple_stained_glass_pane": "mor boyalı i̇nce cam",
  "block.minecraft.blue_stained_glass_pane": "mavi boyalı i̇nce cam",
  "block.minecraft.brown_stained_glass_pane": "kahverengi boyalı i̇nce cam",
  "block.minecraft.green_stained_glass_pane": "yeşil boyalı i̇nce cam",
  "block.minecraft.red_stained_glass_pane": "kırmızı boyalı i̇nce cam",
  "block.minecraft.black_stained_glass_pane": "siyah boyalı i̇nce cam",
  "block.minecraft.prismarine": "prizmarin",
  "block.minecraft.prismarine_bricks": "prizmarin tuğla",
  "block.minecraft.dark_prismarine": "koyu prizmarin",
  "block.minecraft.prismarine_stairs": "prizmarin merdiven",
  "block.minecraft.prismarine_brick_stairs": "prizmarin tuğlası merdiven",
  "block.minecraft.dark_prismarine_stairs": "koyu prizmarin merdiven",
  "block.minecraft.sea_lantern": "deniz feneri",
  "block.minecraft.red_sandstone": "kırmızı kum taşı",
  "block.minecraft.chiseled_red_sandstone": "oyma kırmızı kum taşı",
  "block.minecraft.cut_red_sandstone": "kesilmiş kırmızı kum taşı",
  "block.minecraft.red_sandstone_stairs": "kırmızı kum taşı merdiven",
  "block.minecraft.repeating_command_block": "yinelenen komut bloğu",
  "block.minecraft.chain_command_block": "zincirleme komut bloğu",
  "block.minecraft.magma_block": "magma bloğu",
  "block.minecraft.nether_wart_block": "nether yumrusu bloğu",
  "block.minecraft.warped_wart_block": "çarpık yumru bloğu",
  "block.minecraft.red_nether_bricks": "kırmızı nether tuğlası",
  "block.minecraft.bone_block": "kemik bloğu",
  "block.minecraft.structure_void": "yapı boşluğu",
  "block.minecraft.observer": "gözlemci",
  "block.minecraft.shulker_box": "shulker kutusu",
  "block.minecraft.white_shulker_box": "beyaz shulker kutusu",
  "block.minecraft.orange_shulker_box": "turuncu shulker kutusu",
  "block.minecraft.magenta_shulker_box": "eflatun shulker kutusu",
  "block.minecraft.light_blue_shulker_box": "açık mavi shulker kutusu",
  "block.minecraft.yellow_shulker_box": "sarı shulker kutusu",
  "block.minecraft.lime_shulker_box": "açık yeşil shulker kutusu",
  "block.minecraft.pink_shulker_box": "pembe shulker kutusu",
  "block.minecraft.gray_shulker_box": "gri shulker kutusu",
  "block.minecraft.light_gray_shulker_box": "açık gri shulker kutusu",
  "block.minecraft.cyan_shulker_box": "camgöbeği shulker kutusu",
  "block.minecraft.purple_shulker_box": "mor shulker kutusu",
  "block.minecraft.blue_shulker_box": "mavi shulker kutusu",
  "block.minecraft.brown_shulker_box": "kahverengi shulker kutusu",
  "block.minecraft.green_shulker_box": "yeşil shulker kutusu",
  "block.minecraft.red_shulker_box": "kırmızı shulker kutusu",
  "block.minecraft.black_shulker_box": "siyah shulker kutusu",
  "block.minecraft.white_glazed_terracotta": "beyaz sırlı terakota",
  "block.minecraft.orange_glazed_terracotta": "turuncu sırlı terakota",
  "block.minecraft.magenta_glazed_terracotta": "eflatun sırlı terakota",
  "block.minecraft.light_blue_glazed_terracotta": "açık mavi sırlı terakota",
  "block.minecraft.yellow_glazed_terracotta": "sarı sırlı terakota",
  "block.minecraft.lime_glazed_terracotta": "açık yeşil sırlı terakota",
  "block.minecraft.pink_glazed_terracotta": "pembe sırlı terakota",
  "block.minecraft.gray_glazed_terracotta": "gri sırlı terakota",
  "block.minecraft.light_gray_glazed_terracotta": "açık gri sırlı terakota",
  "block.minecraft.cyan_glazed_terracotta": "camgöbeği sırlı terakota",
  "block.minecraft.purple_glazed_terracotta": "mor sırlı terakota",
  "block.minecraft.blue_glazed_terracotta": "mavi sırlı terakota",
  "block.minecraft.brown_glazed_terracotta": "kahverengi sırlı terakota",
  "block.minecraft.green_glazed_terracotta": "yeşil sırlı terakota",
  "block.minecraft.red_glazed_terracotta": "kırmızı sırlı terakota",
  "block.minecraft.black_glazed_terracotta": "siyah sırlı terakota",
  "block.minecraft.white_concrete": "beyaz beton",
  "block.minecraft.orange_concrete": "turuncu beton",
  "block.minecraft.magenta_concrete": "eflatun beton",
  "block.minecraft.light_blue_concrete": "açık mavi beton",
  "block.minecraft.yellow_concrete": "sarı beton",
  "block.minecraft.lime_concrete": "açık yeşil beton",
  "block.minecraft.pink_concrete": "pembe beton",
  "block.minecraft.gray_concrete": "gri beton",
  "block.minecraft.light_gray_concrete": "açık gri beton",
  "block.minecraft.cyan_concrete": "camgöbeği beton",
  "block.minecraft.purple_concrete": "mor beton",
  "block.minecraft.blue_concrete": "mavi beton",
  "block.minecraft.brown_concrete": "kahverengi beton",
  "block.minecraft.green_concrete": "yeşil beton",
  "block.minecraft.red_concrete": "kırmızı beton",
  "block.minecraft.black_concrete": "siyah beton",
  "block.minecraft.white_concrete_powder": "beyaz çimento",
  "block.minecraft.orange_concrete_powder": "turuncu çimento",
  "block.minecraft.magenta_concrete_powder": "eflatun çimento",
  "block.minecraft.light_blue_concrete_powder": "açık mavi çimento",
  "block.minecraft.yellow_concrete_powder": "sarı çimento",
  "block.minecraft.lime_concrete_powder": "açık yeşil çimento",
  "block.minecraft.pink_concrete_powder": "pembe çimento",
  "block.minecraft.gray_concrete_powder": "gri çimento",
  "block.minecraft.light_gray_concrete_powder": "açık gri çimento",
  "block.minecraft.cyan_concrete_powder": "camgöbeği çimento",
  "block.minecraft.purple_concrete_powder": "mor çimento",
  "block.minecraft.blue_concrete_powder": "mavi çimento",
  "block.minecraft.brown_concrete_powder": "kahverengi çimento",
  "block.minecraft.green_concrete_powder": "yeşil çimento",
  "block.minecraft.red_concrete_powder": "kırmızı çimento",
  "block.minecraft.black_concrete_powder": "siyah çimento",
  "block.minecraft.turtle_egg": "kaplumbağa yumurtası",
  "block.minecraft.dead_tube_coral_block": "ölü tüp mercanı bloğu",
  "block.minecraft.dead_brain_coral_block": "ölü beyin mercanı bloğu",
  "block.minecraft.dead_bubble_coral_block": "ölü baloncuk mercanı bloğu",
  "block.minecraft.dead_fire_coral_block": "ölü ateş mercanı bloğu",
  "block.minecraft.dead_horn_coral_block": "ölü boynuz mercanı bloğu",
  "block.minecraft.tube_coral_block": "tüp mercan bloğu",
  "block.minecraft.brain_coral_block": "beyin mercanı bloğu",
  "block.minecraft.bubble_coral_block": "baloncuk mercanı bloğu",
  "block.minecraft.fire_coral_block": "ateş mercanı bloğu",
  "block.minecraft.horn_coral_block": "boynuz mercanı bloğu",
  "block.minecraft.tube_coral": "tüp mercanı",
  "block.minecraft.brain_coral": "beyin mercanı",
  "block.minecraft.bubble_coral": "baloncuk mercanı",
  "block.minecraft.fire_coral": "ateş mercanı",
  "block.minecraft.horn_coral": "boynuz mercanı",
  "block.minecraft.dead_brain_coral": "ölü beyin mercanı",
  "block.minecraft.dead_bubble_coral": "ölü baloncuk mercanı",
  "block.minecraft.dead_fire_coral": "ölü ateş mercanı",
  "block.minecraft.dead_horn_coral": "ölü boynuz mercanı",
  "block.minecraft.dead_tube_coral": "ölü tüp mercanı",
  "block.minecraft.tube_coral_fan": "tüp mercanı yelpazesi",
  "block.minecraft.brain_coral_fan": "beyin mercanı yelpazesi",
  "block.minecraft.bubble_coral_fan": "baloncuk mercanı yelpazesi",
  "block.minecraft.fire_coral_fan": "ateş mercanı yelpazesi",
  "block.minecraft.horn_coral_fan": "boynuz yelpaze mercanı",
  "block.minecraft.dead_tube_coral_fan": "ölü tüp mercanı yelpazesi",
  "block.minecraft.dead_brain_coral_fan": "ölü beyin mercanı yelpazesi",
  "block.minecraft.dead_bubble_coral_fan": "ölü baloncuk mercanı yelpazesi",
  "block.minecraft.dead_fire_coral_fan": "ölü ateş mercanı yelpazesi",
  "block.minecraft.dead_horn_coral_fan": "ölü boynuz mercanı yelpazesi",
  "block.minecraft.blue_ice": "mavi buz",
  "block.minecraft.conduit": "oluk",
  "block.minecraft.polished_granite_stairs": "cilalı granit merdiven",
  "block.minecraft.smooth_red_sandstone_stairs": "düzgün kırmızı kum taşı merdiven",
  "block.minecraft.mossy_stone_brick_stairs": "yosunlu taş tuğla merdiven",
  "block.minecraft.polished_diorite_stairs": "cilalı diyorit merdiven",
  "block.minecraft.mossy_cobblestone_stairs": "yosunlu kırık taş merdiven",
  "block.minecraft.end_stone_brick_stairs": "end taşı tuğlası merdiven",
  "block.minecraft.stone_stairs": "taş merdiven",
  "block.minecraft.smooth_sandstone_stairs": "düzgün kum taşı merdiven",
  "block.minecraft.smooth_quartz_stairs": "düzgün kuvars merdiven",
  "block.minecraft.granite_stairs": "granit merdiven",
  "block.minecraft.andesite_stairs": "andezit merdiven",
  "block.minecraft.red_nether_brick_stairs": "kırmızı nether tuğlası merdiven",
  "block.minecraft.polished_andesite_stairs": "cilalı andezit merdiven",
  "block.minecraft.diorite_stairs": "diyorit merdiven",
  "block.minecraft.polished_granite_slab": "cilalı granit basamak",
  "block.minecraft.smooth_red_sandstone_slab": "düzgün kırmızı kum taşı basamak",
  "block.minecraft.mossy_stone_brick_slab": "yosunlu taş tuğla basamak",
  "block.minecraft.polished_diorite_slab": "cilalı diyorit basamak",
  "block.minecraft.mossy_cobblestone_slab": "yosunlu kırık taş basamak",
  "block.minecraft.end_stone_brick_slab": "end taşı tuğlası basamak",
  "block.minecraft.smooth_sandstone_slab": "düzgün kum taşı basamak",
  "block.minecraft.smooth_quartz_slab": "düzgün kuvars basamak",
  "block.minecraft.granite_slab": "granit basamak",
  "block.minecraft.andesite_slab": "andezit basamak",
  "block.minecraft.red_nether_brick_slab": "kırmızı nether tuğlası basamak",
  "block.minecraft.polished_andesite_slab": "cilalı andezit basamak",
  "block.minecraft.diorite_slab": "diyorit basamak",
  "block.minecraft.scaffolding": "i̇skele",
  "block.minecraft.iron_door": "demir kapı",
  "block.minecraft.oak_door": "meşe kapı",
  "block.minecraft.spruce_door": "ladin kapı",
  "block.minecraft.birch_door": "huş kapı",
  "block.minecraft.jungle_door": "orman ağacı kapı",
  "block.minecraft.acacia_door": "akasya kapı",
  "block.minecraft.dark_oak_door": "koyu meşe kapı",
  "block.minecraft.crimson_door": "kızıl kapı",
  "block.minecraft.warped_door": "çarpık kapı",
  "block.minecraft.repeater": "kızıl taş yineleyici",
  "block.minecraft.comparator": "kızıl taş karşılaştırıcı",
  "block.minecraft.structure_block": "yapı bloğu",
  "block.minecraft.jigsaw": "yapboz bloğu",
  "item.minecraft.turtle_helmet": "kaplumbağa kabuğu□□kafadayken:□+2 zırh",
  "item.minecraft.scute": "kaplumbağa kabuğu pulu",
  "item.minecraft.iron_shovel": "demir kürek□□ana eldeyken:□+3.5 saldırı hasarı□-3 saldırı hızı",
  "item.minecraft.iron_pickaxe": "demir kazma□□ana eldeyken:□+3 saldırı hasarı□-2.8 saldırı hızı",
  "item.minecraft.iron_axe": "demir balta□□ana eldeyken:□+8 saldırı hasarı□-3.1 saldırı hızı",
  "item.minecraft.flint_and_steel": "çakmak taşı ve çelik",
  "item.minecraft.apple": "elma",
  "item.minecraft.bow": "yay",
  "item.minecraft.arrow": "ok",
  "item.minecraft.coal": "kömür",
  "item.minecraft.charcoal": "odun kömürü",
  "item.minecraft.diamond": "elmas",
  "item.minecraft.iron_ingot": "demir külçesi",
  "item.minecraft.gold_ingot": "altın külçesi",
  "item.minecraft.netherite_ingot": "netherit külçesi",
  "item.minecraft.netherite_scrap": "netherit hurdası",
  "item.minecraft.iron_sword": "demir kılıç□□ana eldeyken:□+5 saldırı hasarı□-2.4 saldırı hızı",
  "item.minecraft.wooden_sword": "tahta kılıç□□ana eldeyken:□+3 saldırı hasarı□-2.4 saldırı hızı",
  "item.minecraft.wooden_shovel": "tahta kürek□□ana eldeyken:□+1.5 saldırı hasarı□-3 saldırı hızı",
  "item.minecraft.wooden_pickaxe": "tahta kazma□□ana eldeyken:□+1 saldırı hasarı□-2.8 saldırı hızı",
  "item.minecraft.wooden_axe": "tahta balta□□ana eldeyken:□+6 saldırı hasarı□-3.2 saldırı hızı",
  "item.minecraft.stone_sword": "taş kılıç□□ana eldeyken:□+4 saldırı hasarı□-2.4 saldırı hızı",
  "item.minecraft.stone_shovel": "taş kürek□□ana eldeyken:□+2.5 saldırı hasarı□-3 saldırı hızı",
  "item.minecraft.stone_pickaxe": "taş kazma□□ana eldeyken:□+2 saldırı hasarı□-2.8 saldırı hızı",
  "item.minecraft.stone_axe": "taş balta□□ana eldeyken:□+8 saldırı hasarı□-3.2 saldırı hızı",
  "item.minecraft.diamond_sword": "elmas kılıç□□ana eldeyken:□+6 saldırı hasarı□-2.4 saldırı hızı",
  "item.minecraft.diamond_shovel": "elmas kürek□□ana eldeyken:□+4.5 saldırı hasarı□-3 saldırı hızı",
  "item.minecraft.diamond_pickaxe": "elmas kazma□□ana eldeyken:□+4 saldırı hasarı□-2.8 saldırı hızı",
  "item.minecraft.diamond_axe": "elmas balta□□ana eldeyken:□+8 saldırı hasarı□-3 saldırı hızı",
  "item.minecraft.stick": "çubuk",
  "item.minecraft.bowl": "kase",
  "item.minecraft.mushroom_stew": "mantar güveç",
  "item.minecraft.golden_sword": "altın kılıç□□ana eldeyken:□+3 saldırı hasarı□-2.4 saldırı hızı",
  "item.minecraft.golden_shovel": "altın kürek□□ana eldeyken:□+1.5 saldırı hasarı□-3 saldırı hızı",
  "item.minecraft.golden_pickaxe": "altın kazma□□ana eldeyken:□+1 saldırı hasarı□-2.8 saldırı hızı",
  "item.minecraft.golden_axe": "altın balta□□ana eldeyken:□+6 saldırı hasarı□-3 saldırı hızı",
  "item.minecraft.netherite_sword": "netherit kılıç□□ana eldeyken:□+7 saldırı hasarı□-2.4 saldırı hızı",
  "item.minecraft.netherite_shovel": "netherit kürek□□ana eldeyken:□+5.5 saldırı hasarı□-3 saldırı hızı",
  "item.minecraft.netherite_pickaxe": "netherit kazma□□ana eldeyken:□+5 saldırı hasarı□-2.8 saldırı hızı",
  "item.minecraft.netherite_axe": "netherit balta□□ana eldeyken:□+9 saldırı hasarı□-3 saldırı hızı",
  "item.minecraft.string": "i̇p",
  "item.minecraft.feather": "tüy",
  "item.minecraft.gunpowder": "barut",
  "item.minecraft.wooden_hoe": "tahta çapa□□ana eldeyken:□-3 saldırı hızı",
  "item.minecraft.stone_hoe": "taş çapa□□ana eldeyken:□-2 saldırı hızı",
  "item.minecraft.iron_hoe": "demir çapa□□ana eldeyken:□-1 saldırı hızı",
  "item.minecraft.diamond_hoe": "elmas çapa□□ana eldeyken:",
  "item.minecraft.golden_hoe": "altın çapa□□ana eldeyken:□-3 saldırı hızı",
  "item.minecraft.netherite_hoe": "netherit çapa□□ana eldeyken:",
  "item.minecraft.wheat_seeds": "buğday tohumu",
  "item.minecraft.wheat": "buğday",
  "item.minecraft.bread": "ekmek",
  "item.minecraft.leather_helmet": "deri şapka□□kafadayken:□+1 zırh",
  "item.minecraft.leather_chestplate": "deri ceket□□gövdedeyken:□+3 zırh",
  "item.minecraft.leather_leggings": "deri pantolon□□bacaktayken:□+2 zırh",
  "item.minecraft.leather_boots": "deri bot□□ayaktayken:□+1 zırh",
  "item.minecraft.chainmail_helmet": "zincir kask□□kafadayken:□+2 zırh",
  "item.minecraft.chainmail_chestplate": "zincir göğüslük□□gövdedeyken:□+5 zırh",
  "item.minecraft.chainmail_leggings": "zincir pantolon□□bacaktayken:□+4 zırh",
  "item.minecraft.chainmail_boots": "zincir bot□□ayaktayken:□+1 zırh",
  "item.minecraft.iron_helmet": "demir kask□□kafadayken:□+2 zırh",
  "item.minecraft.iron_chestplate": "demir göğüslük□□gövdedeyken:□+6 zırh",
  "item.minecraft.iron_leggings": "demir pantolon□□bacaktayken:□+5 zırh",
  "item.minecraft.iron_boots": "demir bot□□ayaktayken:□+2 zırh",
  "item.minecraft.diamond_helmet": "elmas kask□□kafadayken:□+3 zırh□+2 zırh sertliği",
  "item.minecraft.diamond_chestplate": "elmas göğüslük□□gövdedeyken:□+8 zırh□+2 zırh sertliği",
  "item.minecraft.diamond_leggings": "elmas pantolon□□bacaktayken:□+6 zırh□+2 zırh sertliği",
  "item.minecraft.diamond_boots": "elmas bot□□ayaktayken:□+3 zırh□+2 zırh sertliği",
  "item.minecraft.golden_helmet": "altın kask□□kafadayken:□+2 zırh",
  "item.minecraft.golden_chestplate": "altın göğüslük□□gövdedeyken:□+5 zırh",
  "item.minecraft.golden_leggings": "altın pantolon□□bacaktayken:□+3 zırh",
  "item.minecraft.golden_boots": "altın bot□□ayaktayken:□+1 zırh",
  "item.minecraft.netherite_helmet": "netherit kask□□kafadayken:□+3 zırh□+3 zırh sertliği□+1 savrulma direnci",
  "item.minecraft.netherite_chestplate": "netherit göğüslük□□gövdedeyken:□+8 zırh□+3 zırh sertliği□+1 savrulma direnci",
  "item.minecraft.netherite_leggings": "netherit pantolon□□bacaktayken:□+6 zırh□+3 zırh sertliği□+1 savrulma direnci",
  "item.minecraft.netherite_boots": "netherit bot□□ayaktayken:□+3 zırh□+3 zırh sertliği□+1 savrulma direnci",
  "item.minecraft.flint": "çakmak taşı",
  "item.minecraft.porkchop": "çiğ domuz pirzolası",
  "item.minecraft.cooked_porkchop": "pişmiş domuz pirzolası",
  "item.minecraft.painting": "tablo",
  "item.minecraft.golden_apple": "altın elma",
  "item.minecraft.enchanted_golden_apple": "büyülü altın elma",
  "block.minecraft.oak_sign": "meşe tabela",
  "block.minecraft.spruce_sign": "ladin tabela",
  "block.minecraft.birch_sign": "huş tabela",
  "block.minecraft.jungle_sign": "orman ağacı tabela",
  "block.minecraft.acacia_sign": "akasya tabela",
  "block.minecraft.dark_oak_sign": "koyu meşe tabela",
  "block.minecraft.crimson_sign": "kızıl tabela",
  "block.minecraft.warped_sign": "çarpık tabela",
  "item.minecraft.bucket": "kova",
  "item.minecraft.water_bucket": "su kovası",
  "item.minecraft.lava_bucket": "lav kovası",
  "item.minecraft.minecart": "vagon",
  "item.minecraft.saddle": "eyer",
  "item.minecraft.redstone": "kızıl taş tozu",
  "item.minecraft.snowball": "kar topu",
  "item.minecraft.oak_boat": "meşe tekne",
  "item.minecraft.leather": "deri",
  "item.minecraft.milk_bucket": "süt kovası",
  "item.minecraft.pufferfish_bucket": "kirpi balığı kovası",
  "item.minecraft.salmon_bucket": "somon kovası",
  "item.minecraft.cod_bucket": "morina kovası",
  "item.minecraft.tropical_fish_bucket": "tropikal balık kovası",
  "item.minecraft.brick": "tuğla",
  "item.minecraft.clay_ball": "kil topu",
  "block.minecraft.dried_kelp_block": "kurutulmuş su yosunu bloğu",
  "item.minecraft.paper": "kağıt",
  "item.minecraft.book": "kitap",
  "item.minecraft.slime_ball": "balçık topu",
  "item.minecraft.chest_minecart": "sandıklı vagon",
  "item.minecraft.furnace_minecart": "fırınlı vagon",
  "item.minecraft.egg": "yumurta",
  "item.minecraft.compass": "pusula",
  "item.minecraft.fishing_rod": "olta",
  "item.minecraft.clock": "saat",
  "item.minecraft.glowstone_dust": "işık taşı tozu",
  "item.minecraft.cod": "çiğ morina",
  "item.minecraft.salmon": "çiğ somon",
  "item.minecraft.tropical_fish": "tropikal balık",
  "item.minecraft.pufferfish": "kirpi balığı",
  "item.minecraft.cooked_cod": "pişmiş morina",
  "item.minecraft.cooked_salmon": "pişmiş somon",
  "item.minecraft.ink_sac": "mürekkep kesesi",
  "item.minecraft.red_dye": "kırmızı boya",
  "item.minecraft.green_dye": "yeşil boya",
  "item.minecraft.cocoa_beans": "kakao çekirdekleri",
  "item.minecraft.lapis_lazuli": "lapis lazuli",
  "item.minecraft.purple_dye": "mor boya",
  "item.minecraft.cyan_dye": "camgöbeği boya",
  "item.minecraft.light_gray_dye": "açık gri boya",
  "item.minecraft.gray_dye": "gri boya",
  "item.minecraft.pink_dye": "pembe boya",
  "item.minecraft.lime_dye": "açık yeşil boya",
  "item.minecraft.yellow_dye": "sarı boya",
  "item.minecraft.light_blue_dye": "açık mavi boya",
  "item.minecraft.magenta_dye": "eflatun boya",
  "item.minecraft.orange_dye": "turuncu boya",
  "item.minecraft.bone_meal": "kemik tozu",
  "item.minecraft.blue_dye": "mavi boya",
  "item.minecraft.brown_dye": "kahverengi boya",
  "item.minecraft.black_dye": "siyah boya",
  "item.minecraft.white_dye": "beyaz boya",
  "item.minecraft.bone": "kemik",
  "item.minecraft.sugar": "şeker",
  "block.minecraft.cake": "pasta",
  "block.minecraft.white_bed": "beyaz yatak",
  "block.minecraft.orange_bed": "turuncu yatak",
  "block.minecraft.magenta_bed": "eflatun yatak",
  "block.minecraft.light_blue_bed": "açık mavi yatak",
  "block.minecraft.yellow_bed": "sarı yatak",
  "block.minecraft.lime_bed": "açık yeşil yatak",
  "block.minecraft.pink_bed": "pembe yatak",
  "block.minecraft.gray_bed": "gri yatak",
  "block.minecraft.light_gray_bed": "açık gri yatak",
  "block.minecraft.cyan_bed": "camgöbeği yatak",
  "block.minecraft.purple_bed": "mor yatak",
  "block.minecraft.blue_bed": "mavi yatak",
  "block.minecraft.brown_bed": "kahverengi yatak",
  "block.minecraft.green_bed": "yeşil yatak",
  "block.minecraft.red_bed": "kırmızı yatak",
  "block.minecraft.black_bed": "siyah yatak",
  "item.minecraft.cookie": "kurabiye",
  "item.minecraft.filled_map": "harita□#0",
  "item.minecraft.shears": "makas",
  "item.minecraft.melon_slice": "karpuz dilimi",
  "item.minecraft.dried_kelp": "kurutulmuş su yosunu",
  "item.minecraft.pumpkin_seeds": "bal kabağı tohumu",
  "item.minecraft.melon_seeds": "karpuz tohumu",
  "item.minecraft.beef": "çiğ i̇nek eti",
  "item.minecraft.cooked_beef": "biftek",
  "item.minecraft.chicken": "çiğ tavuk eti",
  "item.minecraft.cooked_chicken": "pişmiş tavuk eti",
  "item.minecraft.rotten_flesh": "çürük et",
  "item.minecraft.ender_pearl": "ender i̇ncisi",
  "item.minecraft.blaze_rod": "blaze çubuğu",
  "item.minecraft.ghast_tear": "ghast gözyaşı",
  "item.minecraft.gold_nugget": "altın parçası",
  "item.minecraft.nether_wart": "nether yumrusu",
  "item.minecraft.potion": "üretilemeyen i̇ksir□etkisiz",
  "item.minecraft.glass_bottle": "cam şişe",
  "item.minecraft.spider_eye": "örümcek gözü",
  "item.minecraft.fermented_spider_eye": "mayalı örümcek gözü",
  "item.minecraft.blaze_powder": "blaze tozu",
  "item.minecraft.magma_cream": "magma kremi",
  "block.minecraft.brewing_stand": "i̇ksir tezgahı",
  "block.minecraft.cauldron": "kazan",
  "item.minecraft.ender_eye": "ender gözü",
  "item.minecraft.glistering_melon_slice": "parlayan karpuz dilimi",
  "item.minecraft.bat_spawn_egg": "yarasa çağırma yumurtası",
  "item.minecraft.bee_spawn_egg": "arı çağırma yumurtası",
  "item.minecraft.blaze_spawn_egg": "blaze çağırma yumurtası",
  "item.minecraft.cat_spawn_egg": "kedi çağırma yumurtası",
  "item.minecraft.cave_spider_spawn_egg": "mağara örümceği çağırma yumurtası",
  "item.minecraft.chicken_spawn_egg": "tavuk çağırma yumurtası",
  "item.minecraft.cod_spawn_egg": "morina çağırma yumurtası",
  "item.minecraft.cow_spawn_egg": "i̇nek çağırma yumurtası",
  "item.minecraft.creeper_spawn_egg": "creeper çağırma yumurtası",
  "item.minecraft.dolphin_spawn_egg": "yunus çağırma yumurtası",
  "item.minecraft.donkey_spawn_egg": "eşek çağırma yumurtası",
  "item.minecraft.drowned_spawn_egg": "boğuk çağırma yumurtası",
  "item.minecraft.elder_guardian_spawn_egg": "yaşlı gardiyan çağırma yumurtası",
  "item.minecraft.enderman_spawn_egg": "enderman çağırma yumurtası",
  "item.minecraft.endermite_spawn_egg": "endermite çağırma yumurtası",
  "item.minecraft.evoker_spawn_egg": "uyandırıcı çağırma yumurtası",
  "item.minecraft.fox_spawn_egg": "tilki çağırma yumurtası",
  "item.minecraft.ghast_spawn_egg": "ghast çağırma yumurtası",
  "item.minecraft.guardian_spawn_egg": "gardiyan çağırma yumurtası",
  "item.minecraft.hoglin_spawn_egg": "hoglin çağırma yumurtası",
  "item.minecraft.horse_spawn_egg": "at çağırma yumurtası",
  "item.minecraft.husk_spawn_egg": "zombi kurusu çağırma yumurtası",
  "item.minecraft.llama_spawn_egg": "lama çağırma yumurtası",
  "item.minecraft.magma_cube_spawn_egg": "magma kübü çağırma yumurtası",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom çağırma yumurtası",
  "item.minecraft.mule_spawn_egg": "katır çağırma yumurtası",
  "item.minecraft.ocelot_spawn_egg": "oselo çağırma yumurtası",
  "item.minecraft.panda_spawn_egg": "panda çağırma yumurtası",
  "item.minecraft.parrot_spawn_egg": "papağan çağırma yumurtası",
  "item.minecraft.phantom_spawn_egg": "hayalet çağırma yumurtası",
  "item.minecraft.pig_spawn_egg": "domuz çağırma yumurtası",
  "item.minecraft.piglin_spawn_egg": "piglin çağırma yumurtası",
  "item.minecraft.pillager_spawn_egg": "yağmacı çağırma yumurtası",
  "item.minecraft.polar_bear_spawn_egg": "kutup ayısı çağırma yumurtası",
  "item.minecraft.pufferfish_spawn_egg": "kirpi balığı çağırma yumurtası",
  "item.minecraft.rabbit_spawn_egg": "tavşan çağırma yumurtası",
  "item.minecraft.ravager_spawn_egg": "yıkıcı çağırma yumurtası",
  "item.minecraft.salmon_spawn_egg": "somon çağırma yumurtası",
  "item.minecraft.sheep_spawn_egg": "koyun çağırma yumurtası",
  "item.minecraft.shulker_spawn_egg": "shulker çağırma yumurtası",
  "item.minecraft.silverfish_spawn_egg": "gümüşçün çağırma yumurtası",
  "item.minecraft.skeleton_spawn_egg": "i̇skelet çağırma yumurtası",
  "item.minecraft.skeleton_horse_spawn_egg": "i̇skelet at çağırma yumurtası",
  "item.minecraft.slime_spawn_egg": "balçık çağırma yumurtası",
  "item.minecraft.spider_spawn_egg": "örümcek çağırma yumurtası",
  "item.minecraft.squid_spawn_egg": "mürekkep balığı çağırma yumurtası",
  "item.minecraft.stray_spawn_egg": "serseri çağırma yumurtası",
  "item.minecraft.strider_spawn_egg": "lavgezer çağırma yumurtası",
  "item.minecraft.trader_llama_spawn_egg": "tüccar laması çağırma yumurtası",
  "item.minecraft.tropical_fish_spawn_egg": "tropikal balık çağırma yumurtası",
  "item.minecraft.turtle_spawn_egg": "kaplumbağa çağırma yumurtası",
  "item.minecraft.vex_spawn_egg": "sinirbozan çağırma yumurtası",
  "item.minecraft.villager_spawn_egg": "köylü çağırma yumurtası",
  "item.minecraft.vindicator_spawn_egg": "i̇ntikamcı çağırma yumurtası",
  "item.minecraft.wandering_trader_spawn_egg": "seyyar tüccar çağırma yumurtası",
  "item.minecraft.witch_spawn_egg": "cadı çağırma yumurtası",
  "item.minecraft.wither_skeleton_spawn_egg": "wither i̇skeleti çağırma yumurtası",
  "item.minecraft.wolf_spawn_egg": "kurt çağırma yumurtası",
  "item.minecraft.zoglin_spawn_egg": "zoglin çağırma yumurtası",
  "item.minecraft.zombie_spawn_egg": "zombi çağırma yumurtası",
  "item.minecraft.zombie_horse_spawn_egg": "zombi at çağırma yumurtası",
  "item.minecraft.zombie_villager_spawn_egg": "zombi köylü çağırma yumurtası",
  "item.minecraft.zombified_piglin_spawn_egg": "zombileşmiş piglin çağırma yumurtası",
  "item.minecraft.experience_bottle": "tecrübe i̇ksiri",
  "item.minecraft.fire_charge": "ateş topu",
  "item.minecraft.writable_book": "kitap ve tüy",
  "item.minecraft.written_book": "yazılı kitap",
  "item.minecraft.emerald": "zümrüt",
  "item.minecraft.item_frame": "eşya çerçevesi",
  "block.minecraft.flower_pot": "saksı",
  "item.minecraft.carrot": "havuç",
  "item.minecraft.potato": "patates",
  "item.minecraft.baked_potato": "pişmiş patates",
  "item.minecraft.poisonous_potato": "zehirli patates",
  "item.minecraft.map": "boş harita",
  "item.minecraft.golden_carrot": "altın havuç",
  "block.minecraft.skeleton_skull": "i̇skelet kafatası",
  "block.minecraft.wither_skeleton_skull": "wither i̇skeleti kafatası",
  "block.minecraft.player_head": "oyuncu kafası",
  "block.minecraft.zombie_head": "zombi kafası",
  "block.minecraft.creeper_head": "creeper kafası",
  "block.minecraft.dragon_head": "ejderha kafası",
  "item.minecraft.carrot_on_a_stick": "havuçlu olta",
  "item.minecraft.warped_fungus_on_a_stick": "çarpık mantarlı olta",
  "item.minecraft.nether_star": "nether yıldızı",
  "item.minecraft.pumpkin_pie": "bal kabağı turtası",
  "item.minecraft.firework_rocket": "havai fişek roketi",
  "item.minecraft.firework_star": "havai fişek yıldızı",
  "item.minecraft.enchanted_book": "büyülü kitap",
  "item.minecraft.nether_brick": "nether tuğlası",
  "item.minecraft.quartz": "nether kuvarsı",
  "item.minecraft.tnt_minecart": "tnt'li vagon",
  "item.minecraft.hopper_minecart": "hunili vagon",
  "item.minecraft.prismarine_shard": "prizmarin parçacığı",
  "item.minecraft.prismarine_crystals": "prizmarin kristali",
  "item.minecraft.rabbit": "çiğ tavşan eti",
  "item.minecraft.cooked_rabbit": "pişmiş tavşan eti",
  "item.minecraft.rabbit_stew": "tavşan yahnisi",
  "item.minecraft.rabbit_foot": "tavşan ayağı",
  "item.minecraft.rabbit_hide": "tavşan postu",
  "item.minecraft.armor_stand": "zırh askısı",
  "item.minecraft.iron_horse_armor": "demir at zırhı",
  "item.minecraft.golden_horse_armor": "altın at zırhı",
  "item.minecraft.diamond_horse_armor": "elmas at zırhı",
  "item.minecraft.leather_horse_armor": "deri at zırhı",
  "item.minecraft.lead": "kayış",
  "item.minecraft.name_tag": "i̇sim etiketi",
  "item.minecraft.command_block_minecart": "komut bloğulu vagon",
  "item.minecraft.mutton": "çiğ koyun eti",
  "item.minecraft.cooked_mutton": "pişmiş koyun eti",
  "block.minecraft.white_banner": "beyaz flama",
  "block.minecraft.orange_banner": "turuncu flama",
  "block.minecraft.magenta_banner": "eflatun flama",
  "block.minecraft.light_blue_banner": "açık mavi flama",
  "block.minecraft.yellow_banner": "sarı flama",
  "block.minecraft.lime_banner": "açık yeşil flama",
  "block.minecraft.pink_banner": "pembe flama",
  "block.minecraft.gray_banner": "gri flama",
  "block.minecraft.light_gray_banner": "açık gri flama",
  "block.minecraft.cyan_banner": "camgöbeği flama",
  "block.minecraft.purple_banner": "mor flama",
  "block.minecraft.blue_banner": "mavi flama",
  "block.minecraft.brown_banner": "kahverengi flama",
  "block.minecraft.green_banner": "yeşil flama",
  "block.minecraft.red_banner": "kırmızı flama",
  "block.minecraft.black_banner": "siyah flama",
  "item.minecraft.end_crystal": "end kristali",
  "item.minecraft.chorus_fruit": "nakarat meyvesi",
  "item.minecraft.popped_chorus_fruit": "patlamış nakarat meyvesi",
  "item.minecraft.beetroot": "pancar",
  "item.minecraft.beetroot_seeds": "pancar tohumu",
  "item.minecraft.beetroot_soup": "pancar çorbası",
  "item.minecraft.dragon_breath": "ejderha nefesi",
  "item.minecraft.splash_potion": "patlayıcı üretilemeyen i̇ksir□etkisiz",
  "item.minecraft.spectral_arrow": "spektral ok",
  "item.minecraft.tipped_arrow": "üretilemeyen i̇ksirli ok□etkisiz",
  "item.minecraft.lingering_potion": "kalıcı üretilemeyen i̇ksir□etkisiz",
  "item.minecraft.shield": "kalkan",
  "item.minecraft.elytra": "elitra",
  "item.minecraft.spruce_boat": "ladin tekne",
  "item.minecraft.birch_boat": "huş tekne",
  "item.minecraft.jungle_boat": "orman ağacı tekne",
  "item.minecraft.acacia_boat": "akasya tekne",
  "item.minecraft.dark_oak_boat": "koyu meşe tekne",
  "item.minecraft.totem_of_undying": "ölmeme totemi",
  "item.minecraft.shulker_shell": "shulker kabuğu",
  "item.minecraft.iron_nugget": "demir parçası",
  "item.minecraft.knowledge_book": "bilgi kitabı",
  "item.minecraft.debug_stick": "hata ayıklama çubuğu",
  "item.minecraft.music_disc_13": "müzik diski□c418 - 13",
  "item.minecraft.music_disc_cat": "müzik diski□c418 - cat",
  "item.minecraft.music_disc_blocks": "müzik diski□c418 - blocks",
  "item.minecraft.music_disc_chirp": "müzik diski□c418 - chirp",
  "item.minecraft.music_disc_far": "müzik diski□c418 - far",
  "item.minecraft.music_disc_mall": "müzik diski□c418 - mall",
  "item.minecraft.music_disc_mellohi": "müzik diski□c418 - mellohi",
  "item.minecraft.music_disc_stal": "müzik diski□c418 - stal",
  "item.minecraft.music_disc_strad": "müzik diski□c418 - strad",
  "item.minecraft.music_disc_ward": "müzik diski□c418 - ward",
  "item.minecraft.music_disc_11": "müzik diski□c418 - 11",
  "item.minecraft.music_disc_wait": "müzik diski□c418 - wait",
  "item.minecraft.music_disc_pigstep": "müzik diski□lena raine - pigstep",
  "item.minecraft.trident": "üçlü mızrak□□ana eldeyken:□+8 saldırı hasarı□-2.9 saldırı hızı",
  "item.minecraft.phantom_membrane": "hayali zar",
  "item.minecraft.nautilus_shell": "notilus kabuğu",
  "item.minecraft.heart_of_the_sea": "denizin kalbi",
  "item.minecraft.crossbow": "arbalet",
  "item.minecraft.suspicious_stew": "şüpheli güveç",
  "block.minecraft.loom": "dokuma tezgahı",
  "item.minecraft.flower_banner_pattern": "flama deseni□çiçek şekli",
  "item.minecraft.creeper_banner_pattern": "flama deseni□creeper şekli",
  "item.minecraft.skull_banner_pattern": "flama deseni□kafatası şekli",
  "item.minecraft.mojang_banner_pattern": "sancak deseni□şey",
  "item.minecraft.globe_banner_pattern": "flama deseni□küre",
  "item.minecraft.piglin_banner_pattern": "flama deseni□domuz burnu",
  "block.minecraft.composter": "gübre varili",
  "block.minecraft.barrel": "varil",
  "block.minecraft.smoker": "duman fırını",
  "block.minecraft.blast_furnace": "maden fırını",
  "block.minecraft.cartography_table": "haritacı masası",
  "block.minecraft.fletching_table": "okçu masası",
  "block.minecraft.grindstone": "bileme taşı",
  "block.minecraft.lectern": "kürsü",
  "block.minecraft.smithing_table": "demirci masası",
  "block.minecraft.stonecutter": "taş kesici",
  "block.minecraft.bell": "çan",
  "block.minecraft.lantern": "fener",
  "block.minecraft.soul_lantern": "ruh feneri",
  "item.minecraft.sweet_berries": "tatlı orman meyveleri",
  "block.minecraft.campfire": "kamp ateşi",
  "block.minecraft.soul_campfire": "ruh kamp ateşi",
  "block.minecraft.shroomlight": "mantarışığı",
  "item.minecraft.honeycomb": "bal peteği",
  "block.minecraft.bee_nest": "arı yuvası",
  "block.minecraft.beehive": "arı kovanı",
  "item.minecraft.honey_bottle": "bal şişesi",
  "block.minecraft.honey_block": "bal bloğu",
  "block.minecraft.honeycomb_block": "bal peteği bloğu",
  "block.minecraft.lodestone": "manyetit",
  "block.minecraft.netherite_block": "netherit bloğu",
  "block.minecraft.ancient_debris": "antik kalıntı",
  "block.minecraft.target": "hedef",
  "block.minecraft.crying_obsidian": "ağlayan obsidyen",
  "block.minecraft.blackstone": "kara taş",
  "block.minecraft.blackstone_slab": "kara taş basamak",
  "block.minecraft.blackstone_stairs": "kara taş merdiven",
  "block.minecraft.gilded_blackstone": "yaldızlı kara taş",
  "block.minecraft.polished_blackstone": "cilalı kara taş",
  "block.minecraft.polished_blackstone_slab": "cilalı kara taş basamak",
  "block.minecraft.polished_blackstone_stairs": "cilalı kara taş merdiven",
  "block.minecraft.chiseled_polished_blackstone": "oyma cilalı kara taş",
  "block.minecraft.polished_blackstone_bricks": "cilalı kara taş tuğla",
  "block.minecraft.polished_blackstone_brick_slab": "cilalı kara taş tuğla basamak",
  "block.minecraft.polished_blackstone_brick_stairs": "cilalı kara taş tuğla merdiven",
  "block.minecraft.cracked_polished_blackstone_bricks": "çatlak cilalı kara taş tuğla",
  "block.minecraft.respawn_anchor": "yeniden doğma sağlayıcısı",
}
export const tr_tr = items; 
